import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class SuDisKapiListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "SuDisKapiListe";
    super(baseUrl);
  }


  getSuDisKapiListe(bolgeKodu: number,mahalleKodu:number,caddeSokakKodu:number){
    return this.get("", { params: { bolgeKodu: bolgeKodu, mahalleKodu: mahalleKodu, caddeSokakKodu: caddeSokakKodu } })

  }

}


export default new SuDisKapiListeAPI();
class  SuDisKapiListeRequest {
  public bolgeKodu: number;
  public mahalleKodu: number;
  public caddeSokakKodu: number;

 
  constructor(bolgeKodu: number,mahalleKodu:number,caddeSokakKodu:number) {
   
      this.bolgeKodu = bolgeKodu;
      this.mahalleKodu = mahalleKodu;
      this.caddeSokakKodu = caddeSokakKodu;

      
  }
}
export { SuDisKapiListeRequest };